<template>
  <v-layout v-bind="$attrs" class="grey lighten-3 pa-3">
    <recipe-statistic
      :value="recipe.prepareTime"
      title="příprava"
    />
    <recipe-statistic
      :value="recipe.totalTime"
      title="celkový čas"
    />
    <recipe-statistic :value="recipe.portions" title="porce" />
  </v-layout>
</template>
<script>
import RecipeStatistic from "@/components/RecipeStatistic";

export default {
  name: "recipe-statistics",
  components: { RecipeStatistic },
  props: {
    recipe: {
      type: Object,
      required: true
    }
  }
};
</script>
